module.exports = "/images/vendor/greenmotion-shared/svgs/cards/Maestro.svg?93826edaf79188fd04190936c0f14394";